export default __webpack_public_path__ + "static/media/google.0dd78068.svg";